import { DEFAULT_MESSAGE_TEMPLATES, DEFAULT_REMINDER_SETTINGS } from './utils/messageCatalog';
export type MessageKey = 'adminAppointmentCreated' | 'appointmentCreated' | 'appointmentCreatedBatch' | 'appointmentConfirmed' | 'appointmentCancelled' | 'appointmentCancelledByClient' | 'appointmentReminder' | 'appointmentReminderSameDay' | 'appointmentRescheduleRequested' | 'appointmentRescheduled' | 'appointmentRescheduleRejected';
export interface MessageTemplate { enabled: boolean; message: string }

export type Attendance = 'online' | 'presencial';

export interface ClinicConfig {
  startHour: string; // "08:00"
  endHour: string; // "18:00"
  slotDurationMinutes: number; // 50
  intervalMinutes: number; // 60 (includes break)
  workingDays: number[]; // 0 = Sun, 1 = Mon, etc.
  blockedDates: string[]; // "YYYY-MM-DD"
  blockedSlots: { date: string; time: string }[];
  attendanceByWeekday: Record<string, Attendance[]>;
  attendanceExceptions: Record<string, Attendance[]>;
  address: string;
  onlineInstructions: string;
  cancellationHours: number;
  whatsappConfig: {
    enabled: boolean;
    instanceUrl: string; // URL da EvolutionAPI
    instanceName: string;
    apiKey: string; // Token da API
  };
  adminNotifications: { phone: string; panelUrl: string };
  reminderSettings: { previousDayHour: string; sameDayHour: string };
  messageTemplates: Record<MessageKey, MessageTemplate>;
}

export interface Appointment {
  attendance?: Attendance;
  rescheduleRequest?: { date: string; time: string; attendance: Attendance; requestedAt: string } | null;
  id: string;
  code?: string; // Unique alphanumeric code
  clientName: string;
  clientPhone: string;
  clientEmail?: string;
  date: string; // "YYYY-MM-DD"
  time: string; // "HH:mm"
  status: 'confirmed' | 'cancelled' | 'pending';
  notes?: string;
  createdAt: string;
}

export interface DaySlot {
  time: string;
  available: boolean;
}

export const DEFAULT_CONFIG: ClinicConfig = {
  startHour: "08:00",
  endHour: "18:00",
  slotDurationMinutes: 50,
  intervalMinutes: 60,
  workingDays: [1, 2, 3, 4, 5], // Mon-Fri
  blockedDates: [],
  blockedSlots: [],
  attendanceByWeekday: { '0': ['online'], '1': ['online'], '2': ['online'], '3': ['online'], '4': ['online'], '5': ['online'], '6': ['online'] },
  attendanceExceptions: {},
  address: '',
  onlineInstructions: 'O link de acesso será enviado pelo WhatsApp após a confirmação.',
  cancellationHours: 24,
  whatsappConfig: {
    enabled: false,
    instanceUrl: '',
    instanceName: '',
    apiKey: ''
  },
  adminNotifications: { phone: '', panelUrl: '' },
  reminderSettings: DEFAULT_REMINDER_SETTINGS,
  messageTemplates: DEFAULT_MESSAGE_TEMPLATES,
};
